import { Wrench } from 'lucide-react';
import { cardBase, ViewAllLink } from './dashboardUtils';

export function MaintenanceWidget({ maintenance, onSelectMaint }) {
  return (
    <div className={`${cardBase} overflow-hidden`}>
      <div className="flex items-center justify-between px-6 pt-5 pb-3">
        <h2 className="text-[15px] font-semibold text-gray-900 flex items-center gap-2">
          <Wrench className="h-4 w-4 text-gray-400" /> Maintenance
        </h2>
        <ViewAllLink to="/maintenance" label="maintenance" />
      </div>
      <div className="px-6 pb-5">
        {maintenance.length === 0 ? (
          <p className="text-[13px] text-gray-400 py-2">No open requests</p>
        ) : (
          <div className="space-y-0">
            {maintenance.slice(0, 5).map(m => (
              <div key={m.id} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0 cursor-pointer hover:bg-gray-50/80 transition-colors" onClick={() => onSelectMaint(m)} data-testid={`maint-item-${m.id}`}>
                <div>
                  <p className="text-[13px] font-medium text-gray-900">{m.title}</p>
                  <p className="text-[11px] text-gray-400 mt-0.5">{m.property_name} {m.unit_number}</p>
                </div>
                <span className={`inline-flex items-center gap-1 text-[11px] font-medium rounded-full px-2.5 py-0.5 ${
                  m.status === 'Urgent' ? 'text-red-700 bg-red-50' : m.status === 'In Progress' ? 'text-amber-700 bg-amber-50' : 'text-gray-600 bg-gray-100'
                }`}>
                  <span className={`h-1.5 w-1.5 rounded-full ${m.status === 'Urgent' ? 'bg-red-500' : m.status === 'In Progress' ? 'bg-amber-500' : 'bg-gray-400'}`} />
                  {m.status || 'Pending'}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
